define('js/globals/displayId',['js/lib/queryString'], function (queryString) {
    'use strict';

    return parseInt(queryString.parse().displayId, 10);
});
